import React from 'react';

import '../../Assets/Ui/IconTooltip.css';

export default class IconTooltip extends React.Component {
    constructor() {
        super();

        this.state = {
            open: false,
            init: false
        };
    }

    render() {
        return (
            <button style={this.props.style} disabled={this.props.disabled} className="IconTooltip" onClick={this.props.onClick}>
                <div
                    className={`tooltip ${
                        this.state.init
                            ? this.state.open
                                ? ''
                                : 'fadeOut'
                            : 'hidden'
                    }`}
                >
                    {this.props.text}
                </div>
                <i
                    className={this.props.icon}
                    onMouseEnter={() =>
                        this.setState({ open: true, init: true })
                    }
                    onMouseLeave={() => this.setState({ open: false })}
                />
            </button>
        );
    }
}
